(function() {
  var tocContainer = document.querySelector('[data-article-toc]');
  if (!tocContainer) return;

  /* Seiten (z.B. Ratgeber) markieren ihren Inhalt mit data-toc-content,
     Blog-Artikel behalten ihre bisherige Klasse als Fallback. */
  var guideContent = document.querySelector('[data-toc-content]');
  var articleContent = guideContent || document.querySelector('.article-template__content');
  if (!articleContent) return;

  var headings = articleContent.querySelectorAll('h2, h3');
  if (headings.length < 2) {
    tocContainer.style.display = 'none';
    return;
  }

  var tocList = tocContainer.querySelector('[data-toc-list]');
  var toggleBtn = tocContainer.querySelector('[data-toc-toggle]');
  var nav = tocContainer.querySelector('[data-toc-nav]');
  var icon = tocContainer.querySelector('[data-toc-icon]');

  var CHEVRON_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2 4.5L6 8.5L10 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function scrollToHeading(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var offset = 80;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* Verzeichnis aufbauen: H2 werden Kapitel, H3 haengen als
     auf-/zuklappbare Unterliste darunter. Gibt es keine H2/H3-Mischung
     (z.B. flache Blog-Artikel), verhaelt sich alles wie bisher. */
  var chapters = [];
  var currentChapter = null;
  var headingMeta = [];

  headings.forEach(function(heading, index) {
    /* Vorhandene IDs respektieren, damit Ueberschriften von aussen
       stabil verlinkbar sind (z.B. /pages/ratgeber#streifen). */
    var id = heading.id || 'section-' + index + '-' + heading.textContent
      .toLowerCase()
      .replace(/[^a-z0-9äöüß]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .substring(0, 40);

    heading.id = id;

    var a = document.createElement('a');
    a.href = '#' + id;
    a.className = 'article-toc__link';
    a.textContent = heading.textContent;
    a.addEventListener('click', function(e) {
      e.preventDefault();
      scrollToHeading(id);
    });

    var isSub = heading.tagName === 'H3' && currentChapter !== null;

    var li = document.createElement('li');
    li.className = 'article-toc__item' + (heading.tagName === 'H3' ? ' article-toc__item--sub' : '');

    if (heading.tagName === 'H2') {
      var row = document.createElement('div');
      row.className = 'article-toc__row';
      row.appendChild(a);
      li.appendChild(row);
      tocList.appendChild(li);
      currentChapter = { li: li, row: row, subList: null, heading: heading };
      chapters.push(currentChapter);
    } else if (isSub) {
      if (!currentChapter.subList) {
        currentChapter.subList = document.createElement('ol');
        currentChapter.subList.className = 'article-toc__sublist';
        currentChapter.li.appendChild(currentChapter.subList);
      }
      li.appendChild(a);
      currentChapter.subList.appendChild(li);
    } else {
      li.appendChild(a);
      tocList.appendChild(li);
    }

    headingMeta.push({ heading: heading, link: a, chapter: currentChapter });
  });

  /* Kapitel mit Unterpunkten bekommen einen Pfeil und starten
     eingeklappt. Klick auf den Kapiteltitel springt zum Kapitel,
     der Pfeil klappt nur auf und zu. */
  chapters.forEach(function(chapter) {
    if (!chapter.subList) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'article-toc__subtoggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Unterpunkte anzeigen');
    btn.innerHTML = CHEVRON_SVG;
    btn.addEventListener('click', function() {
      var open = chapter.li.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
    chapter.row.appendChild(btn);
    chapter.btn = btn;
  });

  function openChapter(chapter) {
    if (!chapter || !chapter.subList || chapter.li.classList.contains('is-open')) return;
    chapter.li.classList.add('is-open');
    if (chapter.btn) chapter.btn.setAttribute('aria-expanded', 'true');
  }

  /* Auf schmalen Screens startet das ganze Verzeichnis eingeklappt,
     damit der Inhalt nicht nach unten rutscht. Am Desktop bleibt es
     als Orientierung offen. */
  if (window.innerWidth < 750) {
    toggleBtn.setAttribute('aria-expanded', 'false');
    nav.style.display = 'none';
    icon.style.transform = 'rotate(-90deg)';
  }

  toggleBtn.addEventListener('click', function() {
    var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', String(!isExpanded));
    nav.style.display = isExpanded ? 'none' : 'block';
    icon.style.transform = isExpanded ? 'rotate(-90deg)' : 'rotate(0deg)';
  });

  /* Beim Lesen die aktive Ueberschrift markieren und das zugehoerige
     Kapitel automatisch aufklappen. */
  function highlightActive() {
    var scrollPos = window.scrollY + 120;
    var activeIndex = 0;

    headingMeta.forEach(function(meta, index) {
      if (meta.heading.offsetTop <= scrollPos) {
        activeIndex = index;
      }
    });

    headingMeta.forEach(function(meta, index) {
      if (index === activeIndex) {
        meta.link.classList.add('article-toc__link--active');
      } else {
        meta.link.classList.remove('article-toc__link--active');
      }
    });

    openChapter(headingMeta[activeIndex] && headingMeta[activeIndex].chapter);
  }

  var scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
    scrollTimeout = requestAnimationFrame(highlightActive);
  }, { passive: true });

  highlightActive();

  /* Nur auf Ratgeber-Seiten: ans Ende jedes Kapitels ein Ruecksprung-
     Link zum Inhaltsverzeichnis. Ein "Weiter zu"-Link waere sinnlos,
     das naechste Kapitel steht ohnehin direkt darunter. */
  if (guideContent) {
    function scrollToToc(e) {
      e.preventDefault();
      if (toggleBtn.getAttribute('aria-expanded') !== 'true') {
        toggleBtn.setAttribute('aria-expanded', 'true');
        nav.style.display = 'block';
        icon.style.transform = 'rotate(0deg)';
      }
      var top = tocContainer.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function makeBackLink() {
      var p = document.createElement('p');
      p.className = 'rg-next';
      var a = document.createElement('a');
      a.href = '#';
      a.textContent = '↑ Zum Inhaltsverzeichnis';
      a.addEventListener('click', scrollToToc);
      p.appendChild(a);
      return p;
    }

    var chapterHeadings = Array.from(guideContent.querySelectorAll('h2'));
    chapterHeadings.forEach(function(heading, index) {
      if (index === 0) return;
      heading.parentNode.insertBefore(makeBackLink(), heading);
    });
    if (chapterHeadings.length) {
      guideContent.appendChild(makeBackLink());
    }
  }
})();
